/**
 * Module dependencies.
 */

import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { routes } from 'src/core/constants/routes';
import { axiosInstance, getApiEndpoint } from 'src/core/utils/requests';

/**
 * Export `logout` request.
 */

export async function logout() {
  try {
    const response = await axiosInstance.post(getApiEndpoint('revokeToken'));

    return response?.data;
  } catch {
    return;
  }
}

/**
 * `LogoutOptions` type.
 */

type LogoutOptions = {
  expired?: boolean;
};

/**
 * Export `useLogout` hook.
 */

export function useLogout(options?: LogoutOptions) {
  const router = useRouter();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      router.push(`${routes.authentication.signIn}${options?.expired ? '?session=expired' : ''}`);
    }
  });
}
